<template>
  <div class="header card p-shadow-3 p-d-flex p-jc-between p-ai-center">
    <i @click="menuOn" class="pi pi-bars p-m-4"></i>
    <Sidebar v-model:visible="visibleMenu">
      <h2>めにゅー（仮）</h2>
      <router-link :to="{ name: 'Home' }">
        <p>検索</p>
      </router-link>
      <router-link :to="{ name: 'List' }">
        <p>リスト</p>
      </router-link>
      <router-link :to="{ name: 'CreateSongs' }">
        <p>歌枠登録 (ログイン必須)</p>
      </router-link>
      <router-link :to="{ name: 'Contract' }">
        <p>利用規約</p>
      </router-link>
      <router-link :to="{ name: 'PrivacyPolicy' }">
        <p>プライバシーポリシー</p>
      </router-link>
    </Sidebar>
    <router-link :to="{ name: 'Home' }">
      <h1 class="title p-ac-center">おうたTube</h1>
    </router-link>
    <i @click="userOn" v-on:click="checkLogin" class="pi pi-user p-m-4"></i>
    <OverlayPanel ref="op" v-model:toggle="visibleUser">
      <div v-if="!isLogin" class="unsign">
        <router-link :to="{ name: 'SignIn' }">
          <p>Sign In</p>
        </router-link>
        <router-link :to="{ name: 'SignUp' }">
          <p>Sign Up</p>
        </router-link>
      </div>
      <p v-if="isLogin" class="clickable" @click="signOut">Sign Out</p>
    </OverlayPanel>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import Sidebar from "primevue/sidebar";
import OverlayPanel from "primevue/overlaypanel";
import firebase from "@/firebase/firebase";

export default defineComponent({
  name: "Header",
  components: {
    Sidebar,
    OverlayPanel,
  },
  data() {
    return {
      visibleMenu: false,
      visibleUser: false,
      isLogin: false,
    };
  },
  methods: {
    menuOn() {
      this.visibleMenu = true;
    },
    userOn() {
      // eslint-disable-next-line
      const tmp = this.$refs.op as any;
      tmp.toggle(event);
    },
    signOut: async function () {
      await firebase.auth().signOut();

      console.log("signout");
      this.userOn();
    },
    checkLogin() {
      this.isLogin = firebase.auth().currentUser != null;
    },
  },
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 60px;
  background-color: #272727;
  color: white;
  z-index: 5;
}
.title {
  text-decoration: none;
  color: white;
}
h1 {
  font-size: 18pt;
  text-decoration: none;
}
i {
  font-size: 18pt;
}
a {
  text-decoration: none;
}
.clickable {
  cursor: pointer;
}
</style>
